import { render } from "./SearchPage.vue?vue&type=template&id=2f535040&ts=true"
import script from "./SearchPage.vue?vue&type=script&lang=ts"
export * from "./SearchPage.vue?vue&type=script&lang=ts"

import "./SearchPage.vue?vue&type=style&index=0&id=2f535040&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__